
//Print settings
export const htmlToPaperConfig = {
    name: '_blank',
    specs: [
        'titlebar=yes',
        'scrollbars=yes',
        'size=landscape'
    ],
    styles: [
        'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
        './stylesForPrint.css'
    ],
}